import { Theme } from "@mui/material";

export default {
    issueDetailDialog: {
        imageListItem: {
            cursor: "pointer",
            border: "1px solid",
            borderColor: (theme: Theme) => theme.palette.divider,
            borderRadius: 1,
            overflow: "hidden",
            transition: "border-color 200ms ease-in-out",
            "&:hover": {
                borderColor: (theme: Theme) => `${theme.palette.brand.light}`,
            },
            "& img": {
                transition: "transform 200ms ease-in-out",
            },
            "&:hover img": {
                transform: "scale(1.03)",
            }
        },
        issueDetailCancelButton: {
            transition: "transform 150ms ease, background-color 150ms cubic-bezier(.4,0,.2,1), box-shadow 150ms ease",
            "&:active": { transform: "scale(0.97)" },
            "&:hover": { backgroundColor: (theme: Theme) => theme.palette.action.hover },
            "&:focus-visible": { boxShadow: (theme: Theme) => `0 0 0 3px ${theme.palette.primary.main}40` },
        },
        issueDetailSaveButton: {
            fontWeight: "bold",
            backgroundColor: (theme: Theme) => theme.palette.brand.main,
            color: (theme: Theme) => theme.palette.primary.contrastText,
            transition: "transform 150ms ease, background-color 150ms cubic-bezier(.4,0,.2,1), box-shadow 150ms ease",
            "&:hover": {
                backgroundColor: (theme: Theme) => theme.palette.brand.dark,
                color: (theme: Theme) => theme.palette.primary.contrastText,
            },
            "&:active": { transform: "scale(0.97)" },
            "&:focus-visible": { boxShadow: (theme: Theme) => `0 0 0 3px ${theme.palette.primary.main}40` },
        }
    },
    issueListItem: {
        itemContainer: {
            backgroundColor: "white",
            position: "relative",
            border: `solid 1px`,
            borderLeft: `solid 15px`,
            padding: 2.5,
            marginBottom: 1.25,
            transition: "all 0.2s ease-in-out 0s",
            textAlign: "left",
            borderRadius: "5px",
            cursor: "pointer",
        },
        statusBox: {
            position: "absolute",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            transform: "rotate(180deg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 15,
            left: -15,
            top: 0,
            bottom: 0,
            fontSize: "10px",
            color: "white",
            overflow: "hidden",
            textAlign: "center",
        },
        listViewBox: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            overflow: "hidden",
        },
        itemCardIcon: {
            fontSize: 24,
            marginLeft: 20,
            marginRight: 20
        }
    },
    colors: {
        red: "rgb(211, 47, 47)",
        amber: "rgb(237, 108, 2)",
        darkGreen: "rgb(46, 125, 50)",
        darkGray: "rgb(97, 97, 97)"
    }
}